export const buildCustomerGeoFenceQueryString = ({
  terminalId,
  customerCode,
  rmaxShipperCode
}) => {
  const params = new URLSearchParams();
  params.set('terminalId', String(terminalId));
  params.set('customerCode', customerCode);
  if (rmaxShipperCode) {
    params.set('rmaxShipperCode', rmaxShipperCode);
  }
  return params.toString();
};

export const getGeoFenceFromResponse = (response) => {
  return response?.data?.[0]?.geoFence || null;
};
